import { useState } from 'react';
import _get from 'lodash/get';
import { Button , Row, Table } from 'react-bootstrap';
import { Input, Modal } from 'components';
import { Formik } from 'formik';
import { useStore, withStore } from 'store';
import { getProductsById, getProductsBySku } from 'services/api/products';
import { getProductDetails } from 'services/gifts';
import { useStorage64Latin, useWindowSize } from 'hooks';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { hideLoader, showLoader } from 'store/actions/commons';
import GiftItem from '../../gifts-table/GiftsList/GiftItem/index';
import { actions, mapStateToProps } from './config';
import Camera from './Camera';
import styles from './styles.module.scss';
import { searchGiftTableFormatter } from 'services/giftTable/formatters';
import { set } from 'lodash';

const ScannerQr = ({
  onClickItem,
  giftTableProducts,
  addProduct,
  deleteProduct,
}) => {
  const [size, setSize] = useState('');
  const [sku, setSku] = useState(0);
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [storageGiftTable] = useStorage64Latin(CURRENT_GIFT_TABLE, {});
  const selected = _get(giftTableProducts, 'results.allElements', []);
  const [, { isMobile }] = useWindowSize();

  const [, dispatch] = useStore((state) => state.giftTable.giftTable);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSubmit = async (value) => {
    if(value) {
      dispatch(showLoader());
      const variant = await getProductsBySku({
        sku: value.search,
      });
      setSku(value.search);
      const productId = variant?.length ? variant[0].id : 0;
      const product = +productId ? [await getProductDetails(productId)] : [];
      if(product.length){
        const sizes = product[0].size_color.map(sc => sc.sizes
          .filter(s => s.variant === value.search)).filter(r => r.length);
        sizes.length && setSize(sizes[0][0].size);
      }
      setProducts(product);
      setShowModal(true);
      dispatch(hideLoader());      
    }
  };
  
  const handleAddProduct = async (product) => {
    const response = await getProductsById([product.id]);
    const detail = response && response.data.length ? response.data[0] : null;
    const variant = detail?.variations?.filter(v => v.sku === product.variant);
    product.variant_id = variant?.length ? variant[0].id : null;
    product.children_sku = variant?.length ? variant[0].sku : null;
    product.ean = detail?.ean;
    product.sku = detail?.sku;

    addProduct(product);
  };

  const handleDeleteProduct = (product) => {
    deleteProduct({ tableId: storageGiftTable.id, productId: product.id });
  };

  return (
    <>
      <div>
        <p>Escanear código de barras para buscar productos de forma rápida y sencilla</p>
        <Camera setShowModal={setShowModal} setProducts={setProducts} />
      </div>
      <p className="text-center">
        <strong>Ingresar código manualmente</strong>
      </p>
      <div className="d-flex flex-column align-items-center">
        <Formik
            initialValues={{
              search: '',
            }}
            onSubmit={handleSubmit}
        >
          {(props) => (
              <form onSubmit={props.handleSubmit} className="d-flex">

                <Table>
                  <tbody>
                  <tr>
                    <td>
                      <Input
                          className={styles.inputborder}
                          id="search"
                          name="search"
                          placeholder="Ingresa el código sku"
                          style={{ fontSize: isMobile?'0.95rem':'1rem' }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="text-center">
                      <Button className={styles.Button} type="submit">
                        Buscar
                      </Button>
                    </td>
                  </tr>
                  </tbody>
                </Table>
              </form>
          )}
        </Formik>
        <Modal
            show={showModal}
            onClose={handleCloseModal}
            withActionButtons={isMobile?((products && products.length === 0)):false}
            showCancel={false}
            variant={(products && products.length !== 0)?'completed':''}
            variantOnlyInMobile
            dialogClassName={`${styles.modalDialog}`}
            onAction={handleCloseModal}
            actionLabel="Escanear otro producto"
            titleHeader={products && products.length !== 0 ? '' : 'Error'}
            titleHeaderClassName={!isMobile?'col-md-6 offset-md-3':'col-md-6 offset-md-3'}
            withHeader={false}
        >
          {products && products.length !== 0 ? (
              products.map((giftProduct) => {
                const isSelected = selected.find(
                    ({ id }) => Number(id) === Number(giftProduct.id)
                );
                // console.log(giftProduct);
                return (
                    <GiftItem
                        onClickGift={onClickItem}
                        onAddGift={handleAddProduct}
                        onDeleteGift={handleDeleteProduct}
                        id={giftProduct.id}
                        item={giftProduct}
                        selected={isSelected}
                        quantity={isSelected?.quantity || 0}
                        showBigPrice
                        bigRenderClassName={styles.GiftItemInModal}
                        productDetailsClassName={styles.productDetails}
                        className={styles.GiftItemInModal}
                        giftTableId={storageGiftTable.evento}
                        showSuccessModal
                        type={!isMobile?'bigDetails':'mobileDetails'}
                        sku={sku}
                        wantedSize={size}
                        showAnotherScan
                        onCancelScan={handleCloseModal}
                        showAllImages={false}
                    />
                );
              })
          ) : (
              <>
                {!isMobile?
                (
                  <div className="text-center">
                    <h1>Producto no encontrado</h1>
                    <Button className={styles.Button} onClick={handleCloseModal} >
                      Aceptar
                    </Button>
                  </div>
                ):
                (
                  <div className="text-center mt-4" style={{fontSize: '1rem'}}>
                    Producto no encontrado
                  </div>
                )
                }
              </>
          )}
        </Modal>
      </div>

    </>
  );
};

export default withStore({ mapStateToProps }, actions)(ScannerQr);
